import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import flattenDeep from 'lodash.flattendeep';
import Icon from 'antd/lib/icon';
import Button from 'antd/lib/button';
import Upload from 'antd/lib/upload';
import message from 'antd/lib/message';

const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB

@translate()
export default class DocumentUpload extends Component {
  static propTypes = {
    onUpload: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    uploadTitle: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
    allowedMimeTypes: PropTypes.array,
    disabled: PropTypes.bool,
    className: PropTypes.string,
  };

  shouldBeFileUploaded = file => {
    const { allowedMimeTypes, t } = this.props;

    // Check file size
    if (file.size > MAX_FILE_SIZE) {
      message.error(
        t('Súbor je príliš veľký. Maximálna povolená veľkosť je 10 MB.'),
        5
      );
      return false;
    }

    if (
      allowedMimeTypes &&
      allowedMimeTypes.map(allowed => allowed.mediaType).indexOf(file.type) === -1
    ) {
      const allowedSuffixes = flattenDeep(allowedMimeTypes.map(allowed => allowed.suffixes))
        .map(suffix => `.${suffix}`)
        .join(', ');
      message.error(
        t('Typ súboru nie je podporovaný. Podporované typy súborov: ') + allowedSuffixes,
        5
      );
      return false;
    }
    return true;
  };

  render() {
    const {
      onRemove,
      onUpload,
      uploadTitle,
      allowedMimeTypes,
      disabled = false,
      className,
    } = this.props;

    const mediaTypes = allowedMimeTypes
      ? allowedMimeTypes.map(allowed => allowed.mediaType).join(',')
      : '*';

    return (
      <Upload
        customRequest={onUpload}
        onRemove={onRemove}
        multiple={false}
        showUploadList={false}
        accept={mediaTypes}
        beforeUpload={this.shouldBeFileUploaded}
      >
        <Button disabled={disabled} size="small" className={className}>
          <Icon type="upload" /> {uploadTitle}
        </Button>
      </Upload>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/documents/components/DocumentUpload.js